// extracted by mini-css-extract-plugin
export default {"new-tag":"styles-module__new-tag___QXqo_"};